import { bindPrototypeMethodsToSelf } from '@wix/panorama-common/utils';
import { type CustomTransactionName } from '@wix/panorama-common-shared/utils';
import { type BasePanoramaClient } from './panorama-client-base';
import {
  type PanoramaErrorMonitor,
  PanoramaErrorMonitorImpl,
} from './panorama-error-monitor';
import { type PanoramaLogger, PanoramaLoggerImpl } from './panorama-logger';
import type {
  ErrorMonitorOptionsForComponent,
  ErrorMonitorUserData,
  TransactionOptions,
} from './types';
import {
  type PanoramaTransaction,
  PanoramaTransactionImpl,
} from './panorama-transaction';

interface Options {
  baseClient: BasePanoramaClient;
}

export interface PanoramaClientForComponent {
  transaction<T extends string>(
    name: CustomTransactionName<T>,
    options?: TransactionOptions,
  ): PanoramaTransaction;

  errorMonitor(
    options?: ErrorMonitorOptionsForComponent,
  ): PanoramaErrorMonitor<ErrorMonitorUserData>;

  logger(): PanoramaLogger;
}

export class PanoramaClientForComponentImpl
  implements PanoramaClientForComponent
{
  private baseClient: BasePanoramaClient;

  constructor({ baseClient }: Options) {
    this.baseClient = baseClient;

    bindPrototypeMethodsToSelf(this);
  }

  transaction(
    name: CustomTransactionName<string>,
    options?: TransactionOptions,
  ) {
    return new PanoramaTransactionImpl(this.baseClient, name, options);
  }

  errorMonitor(
    options?: ErrorMonitorOptionsForComponent,
  ): PanoramaErrorMonitor<ErrorMonitorUserData> {
    return new PanoramaErrorMonitorImpl(this.baseClient, options);
  }

  logger(): PanoramaLogger {
    return new PanoramaLoggerImpl(this.baseClient);
  }
}
